import { postPushNotificationsApiHeaders } from '@module/mdrt-org/shared/utils/helpers/get-headers';
import { mutateWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/mutate-with-error-handling';

export const postWebPushSubscription = async ({
  accessToken,
  auth,
  deviceId,
  endpoint,
  expirationTime,
  p256dh,
  personId,
  userAgent,
}: {
  accessToken: string | undefined;
  auth: string;
  deviceId: string;
  endpoint: string;
  expirationTime?: null | number;
  p256dh: string;
  personId: number | undefined;
  userAgent: string | undefined;
}) => {
  if (!(accessToken && personId)) {
    throw new Error('Access token or person ID is not available');
  }

  await mutateWithErrorHandling(
    `${window.PUBLIC_ENV.apiBaseUrl}/${
      window.PUBLIC_ENV.notificationsApiRoute ?? 'notifications-api'
    }/Notifications/Users/${personId}/WebPush`,
    {
      body: JSON.stringify({ auth, deviceId, endpoint, expirationTime, p256dh, userAgent }),
      headers: {
        ...postPushNotificationsApiHeaders(accessToken),
      },
      method: 'PATCH',
    }
  );

  return null;
};
